import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useFormContext } from '../../contexts/formContext';
import Tooltip from '../Tooltip';
import useFieldStyles from './Field.styles';

const SelectField = ({ className, name, label, options, placeholder, disabled, onChange, forceEnabled }) => {
  const fieldClasses = useFieldStyles();

  const [field, meta] = useField({ name });

  const { disabled: formDisabled } = useFormContext();

  const errorMessage = useMemo(() => (meta.touched && meta.error ? meta.error : ''), [meta.touched, meta.error]);

  const handleChange = useCallback(
    (event) => {
      field.onChange(event);
      if (onChange) onChange(event.target.value);
    },
    [onChange, field]
  );

  return (
    <div className={className}>
      <Tooltip title={errorMessage} placement="bottom" classes={{ tooltip: fieldClasses.tooltip }}>
        <FormControl className={fieldClasses.root}>
          {!!label && <InputLabel id="select-label">{label}</InputLabel>}

          <Select
            id={name}
            labelId="select-label"
            value={field.value}
            onChange={handleChange}
            name={field.name}
            placeholder={placeholder}
            disabled={!forceEnabled && (formDisabled || disabled)}
            error={!!(meta.touched && meta.error)}>
            <MenuItem value="">-</MenuItem>

            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Tooltip>
    </div>
  );
};

SelectField.propTypes = {
  disabled: PropTypes.bool,
  forceEnabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

SelectField.defaultProps = {
  disabled: false,
  forceEnabled: false,
  label: '',
  onChange: undefined,
  placeholder: '',
  className: undefined,
};

export default React.memo(SelectField);
